import { Field, getFormValues } from "redux-form";
import { Icon, ReduxControls } from "rhombus-react";
import { required } from "forms/validators/validators";
import React from "react";
import { useSelector } from "react-redux";
import { SUBMIT_QR_CODE_FORM } from "forms/list";

export const validCharsForExtraParams = (value) => {
	const pattern = /^[A-Za-z0-9\-_.\s]*$/;
	const message = "Invalid characters in use. Allowed characters are: 'A-Z', 'a-z', '0-9', '-', '_', '.', and whitespaces";
	if (value && !pattern.test(value)) {
		return message;
	}
};
export const ExtraParameterSection = (props) => {
	const { name, removeExtraParam, extraParameterIndex } = props;
	const formState = useSelector(getFormValues(SUBMIT_QR_CODE_FORM));
	const extraParam = formState.extraParams[extraParameterIndex];

	return (
		<div className="input-extra-params-container">
			<div className="sm-input-extra-params">
				<Field
					key={`${name}-key`}
					name={`${name}.key`}
					type="text"
					placeholder="Enter name..."
					component={ReduxControls.Input}
					validate={!!extraParam.value ? [required, validCharsForExtraParams] : [validCharsForExtraParams]}
					disabled={props.readOnly}
				/>
			</div>
			<div className="sm-input-extra-params">
				<Field
					key={`${name}-value`}
					name={`${name}.value`}
					type="text"
					placeholder="Enter value..."
					component={ReduxControls.Input}
					validate={!!extraParam.key ? [required, validCharsForExtraParams] : [validCharsForExtraParams]}
					disabled={props.readOnly}
				/>
			</div>
			{ !props.readOnly
				&& <div className="rm-extra-param-btn">
					<Icon name="removeCircle" onClick={removeExtraParam} />
				</div>
			}
		</div>
	);
};

ExtraParameterSection.displayName = "ExtraParameterSection";
